export const errorCodes = {
  RESOURCE_NOT_FOUND: 40400,
  MEDICAL_CENTER_NOT_FOUND: 40002,
};
